<template>
  <div class="editInfo">
    <el-form ref="baseform" :rules="rules" :model="params" label-width="80px">
        <el-form-item label="姓名" prop="nickname">
            <el-input
                clearable
                v-model="params.nickname"
                placeholder="姓名"
                :disabled="user_disabled"
            ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
            <el-input
                clearable
                v-model="params.phone"
                placeholder="手机号"
                :disabled="user_disabled"
            ></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
            <el-input
                clearable
                v-model="params.email"
                placeholder="邮箱"
                :disabled="user_disabled"
            ></el-input>
        </el-form-item>
        <el-form-item label="属地" prop="region_id">
          <el-select
            v-model="params.region_id"
            clearable
            placeholder="属地"
            :disabled="user_disabled"
            filterable
          >
              <el-option
              v-for="item in options.dealer_territory_arr"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              >
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select
                v-model="params.status"
                clearable
                placeholder="状态"
                :disabled="user_disabled"
            >
                <el-option
                v-for="item in options.status_arr"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                >
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="创建时间" prop="created_at" v-show="type && !editText">
            <el-input
                clearable
                v-model="params.created_at"
                placeholder="创建时间"
                disabled="disabled"
            ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password" v-if="editText">
          <el-input
            type="text"
            clearable
            v-model="params.password"
            :disabled="user_disabled"
            placeholder="新密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirm_password" v-if="editText">
          <el-input
            type="text"
            clearable
            v-model="params.confirm_password"
            placeholder="确认密码"
            :disabled="user_disabled"
          ></el-input>
        </el-form-item>
    </el-form>
    <div class="row btnEdit">
      <el-button
        v-if="!type"
        type="primary"
        @click="saveHandle"
        v-loading="saveLoading"
      >保存</el-button>
      <el-button
        v-else-if="type && !editText"
        type="primary"
        @click="editHandle"
      >编辑</el-button>
      <el-button
        v-else
        type="primary"
        @click="saveEdit"
      >保存修改</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userEditor',
  props: {
    type: {
      type: String
    },
    params: {
      type: Object,
      default () {
        return {
          nickname: '', // 姓名
          phone: '', // 电话
          email: '', // 邮箱
          region_id: '', // 归属地
          status: '', // 状态
          password: '', // 密码
          created_time: '', // 创建时间
          confirm_password: '', // 确认密码
          created_at: '',
          id: '' // id
        }
      }
    },
    status: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    status (val) {
      if (val) {
        this.user_disabled = true
        this.editText = false
      }
    }
  },
  data () {
    return {
      user_disabled: false,
      selRoleAndOthersList: [],
      options: {
        dealer_territory_arr: [], // 属地
        status_arr: [] // 状态
      },
      editText: false,
      saveLoading: false,
      rules: {
        region_id: [
          { required: true, message: '属地不能为空' }
        ],
        nickname: [
          { required: true, message: '姓名不能为空' }
        ],
        status: [{ required: true, message: '状态不能为空' }],
        phone: [
          { required: true, message: '手机号不能为空' },
          {
            validator: (rule, value, callback) => {
              const phoneReg = /^1\d{10}$/
              if (phoneReg.test(value)) {
                callback()
              } else {
                callback(new Error('电话号码格式不正确'))
              }
            },
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: '邮箱不能为空' },
          {
            validator: (rule, value, callback) => {
              const mailReg = /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/i
              if (mailReg.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确的邮箱格式'))
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    saveEdit () {
      this.$refs['baseform'].validate((valid) => {
        if (valid) {
          this.$emit('saveEdit', this.params)
        }
      })
    },
    saveHandle () {
      //  保存
      this.saveLoading = true
      this.$refs['baseform'].validate((valid) => {
        if (valid) {
          this.$emit('saveHandle', this.params)
        }
      })
      this.saveLoading = false
    },
    setOptions () {
      this.axios.get('/home/projectmanager/dealerUserAccount/filterConditionList').then(({ data }) => {
        let { rows, success } = data
        if (success) {
          this.options = rows
        }
      })
    },
    setdefaultSel () {
      this.setOptions()
    },
    editHandle () {
      this.user_disabled = false
      this.editText = true
      this.$emit('update:status', false)
    },
    resetData () {
      this.params.password = ''
      this.params.confirmPassword = ''
    }
  },
  mounted () {
    this.setOptions()
    if (this.type === '1' && this.params.status !== 3) { // 1 进入的查看页面
      this.user_disabled = true
    }
  }
}
</script>

<style lang="scss" scoped>
.editInfo {
  margin: 8px 23px 10px 23px;
}
/deep/
.el-select,
.el-input {
  width: 180px;
  margin-right:15px
}
/deep/
.el-form-item {
  margin-bottom: 15px;
}
/deep/
.el-button {
  margin-left: 80px;
}
</style>
